<template>
  <a-config-provider :locale="id_ID">
    <div id="app" v-if="!getIsPublik">
      <a-layout class="based-layout" id="app" v-if="isMobile">
        <a-affix :offsetTop="this.top">
          <a-layout-header class="m-header-mobile">
            <a-icon
              class="header-trigger"
              type="menu-fold"
              v-on="
                isMobile
                  ? { click: () => showDrawer() }
                  : { click: () => showNavigation() }
              "
            />
            <img class="m-brand" src="@/assets/logo.png" alt="logo-mobile" />
            <div class="header-trigger" @click="handleNotification">
              <a-badge
                class="m-badge m-badge-small"
                :count="countNotif"
                :numberStyle="{ backgroundColor: 'red' }"
                v-if="
                  getNotification.aksi.length > 0 ||
                    getNotification.informasi.length > 0
                "
              >
                <a-icon type="notification" />
              </a-badge>
              <a-icon type="notification" v-else />
            </div>
          </a-layout-header>
        </a-affix>
        <Navigation ref="navigation" />
        <router-view class="p-all" />
      </a-layout>
      <a-layout class="based-layout" id="app" v-else>
        <Navigation />
        <a-layout-content
          class="d-flex flex-column justify-around"
          v-if="getPageLoading"
        >
          <a-spin
            type="loading"
            tip="Tunggu Sebentar, Halaman Kamu Sedang Disiapkan!"
          ></a-spin>
        </a-layout-content>
        <a-layout :class="!isMobile ? 'based-content' : ''">
          <router-view />
        </a-layout>
      </a-layout>
      <keep-alive>
        <H-Notification :visible="getNotificationView" />
      </keep-alive>
    </div>
    <div id="app" v-else>
      <a-layout :class="!isMobile ? 'main-layout' : 'm-layout'">
        <a-layout>
          <transition>
            <router-view />
          </transition>
        </a-layout>
      </a-layout>
    </div>
  </a-config-provider>
</template>

<script>
import id_ID from "ant-design-vue/lib/locale-provider/id_ID";
import Navigation from "@/views/layout/Navigation";
import Notification from "@/components/Notification.vue";
import { mapGetters } from "vuex";

export default {
  name: "app",
  data() {
    return {
      id_ID,
      top: 0
    };
  },
  computed: {
    ...mapGetters([
      "getPageLoading",
      "getAuth",
      "getIsLogin",
      "getIsPublik",
      "getMenus",
      "getNotificationView",
      "getNotification",
      "getLayoutNonScroll"
    ]),
    countNotif() {
      let count =
        this.getNotification.aksi.length +
        this.getNotification.informasi.length;
      return count;
    }
  },
  mounted() {
    this.$store.dispatch("SET_PAGE_LOADING", false);
    this.$store.dispatch("FETCH_MENUS");
    this.$store.dispatch("FETCH_MASTER");
  },
  components: {
    Navigation,
    "H-Notification": Notification
  },
  methods: {
    showDrawer() {
      this.$refs.navigation.showDrawer();
    },
    handleNotification() {
      this.$store.dispatch("SET_NOTIFICATION_VIEW");
    }
  }
};
</script>

<style lang="less" scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
